import React from 'react';
import Element, { CommonProps } from '../Element/Element';
import styles from './SpinningLoader.module.scss';
import { ArrayElementType } from '../../types/utils/ArrayElementType';

export const supportedSpinningLoaderSizes = ['sm', 'md', 'lg'] as const;
export type SupportedSpinningLoaderSizes = ArrayElementType<
  typeof supportedSpinningLoaderSizes
>;

type SpinningLoaderProps = {
  /** Size of the loader */
  size?: SupportedSpinningLoaderSizes;
} & CommonProps<'span'>;

const SpinningLoader: React.FunctionComponent<SpinningLoaderProps> = ({
  className,
  size = 'lg',
  ...props
}) => {
  const cssClassBySize: { [key: string]: string } = {
    sm: 'spinningLoaderSmall',
    md: 'spinningLoaderMedium',
    lg: 'spinningLoaderLarge',
  };

  const loaderSize = cssClassBySize[size];

  return (
    <Element tagName="span" className={className} {...props}>
      <svg
        className={styles[`${loaderSize}`]}
        width="64"
        height="64"
        viewBox="0 0 64 64"
      >
        <g>
          <path
            d="M56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32H0C7.72511e-07 14.3269 14.3269 -7.7252e-07 32 0C49.6731 7.72511e-07 64 14.3269 64 32H56Z
               M60 36C57.7909 36 56 34.2091 56 32C56 29.7909 57.7909 28 60 28C62.2091 28 64 29.7909 64 32C64 34.2091 62.2091 36 60 36Z"
            fill="url(#paint0_linear)"
          />

          <path
            d="M8 32C8 45.2548 18.7452 56 32 56V64C14.3269 64 0 49.6731 0 31.95H8Z"
            fill="url(#paint1_linear)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="49.3638"
            y1="8.15909"
            x2="6.82861"
            y2="29.9562"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#990AE3" />
            <stop offset="1" stopColor="#BC6BE6" />
          </linearGradient>

          <linearGradient
            id="paint1_linear"
            x1="5.20659"
            y1="33.7612"
            x2="32"
            y2="64"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#BC6BE6" />
            <stop
              offset="0.0972687"
              stopColor="#C074E7"
              stopOpacity="0.940565"
            />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </Element>
  );
};

export default SpinningLoader;
